import { axiosClient, getBaseUrlVersioned } from "../../../services/axiosClient";
/**
 * `POST /rulebooks/playtest` — dry-run one Rulebook turn against the submitted draft on the server:
 * validation, deterministic evaluation, AI trace (simulated or evaluator), final state.
 */
export default async function playtestRulebook(request) {
    const apiUrl = `${getBaseUrlVersioned(null)}/rulebooks/playtest`;
    const response = await axiosClient.post(apiUrl, request);
    return response["data"];
}
